import state from './moduleCampaignState.js'
import mutations from './moduleCampaignMutations.js'
import actions from './moduleCampaignActions.js'
import getters from './moduleCampaignGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
